import React, { useState, useEffect, useRef } from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const AGENTS_IMAGE = "https://customer-assets.emergentagent.com/job_bfedec72-4b0a-40b7-bc77-158aaceb834b/artifacts/91bkg8d0_53ac3571-the-5-club-website-1_10rk04i000000000000028.png";

const AgentLogosSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-14 md:py-20 bg-black overflow-hidden">
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className={`flex flex-col items-center text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          
          {/* Agent Faces Image */}
          <div className="mb-8 max-w-md md:max-w-lg">
            <img 
              src={AGENTS_IMAGE}
              alt="Gazeal Agent Network"
              className="w-full h-auto"
            />
          </div>

          {/* Main Heading */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 heading">
            Join <span className="text-[#59d862] relative">
              1,000+
              <span className="absolute -bottom-1 left-0 right-0 h-1 bg-[#59d862]/30" />
            </span> Agents
            <br />
            <span className="text-white/80">Across the UK</span>
          </h2>

          {/* CTA Button */}
          <Link 
            to="/apply" 
            className="btn-primary px-8 py-3 inline-flex items-center gap-2 text-base group"
          >
            Join the Network 
            <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AgentLogosSection;
